// extracted by mini-css-extract-plugin
export default {"messageIcon":"message_messageIcon__uAbA2"};